import React from 'react';
import P from 'prop-types';

import { Box } from '@nerdwallet/currency';
import classNames from 'classnames';

import '../flex-card-v2.less';
import UniversalContainer from '../../universal-container';
import UniversalText from '../../universal-text/universal-text';
import UniversalImage from '../../universal-image/universal-image';
import UniversalButton from '../../universal-button/universal-button';

const FlexCardItem = ({
  desktopCarousel,
  // V2 Props
  flexCardItemContainer,
  eyebrow,
  title,
  subtitle,
  bodyCopy,
  cardImage,
  cardLabel,
  cardButton,
  alignment,
}) => {
  return (
    <UniversalContainer
      {...flexCardItemContainer}
      style={{ placeSelf: alignment, height: 'inherit' }}
    >
      <Box
        padding="2"
        className={classNames('flex-card-item', {
          carousel: desktopCarousel,
        })}
      >
        <UniversalImage
          {...cardImage}
          style={{ display: 'flex', justifyContent: 'center' }}
        />
        <Box>
          <UniversalText
            {...eyebrow}
            defaultOptions={{ text: { textType: 'accent' } }}
          />
          <UniversalText {...title} />
          <UniversalText
            {...subtitle}
            defaultOptions={{ text: { textType: 'text' } }}
          />
          <UniversalText
            {...bodyCopy}
            defaultOptions={{ text: { textType: 'text' } }}
          />
          <UniversalText
            {...cardLabel}
            defaultOptions={{ text: { textType: 'text' } }}
          />
          {cardButton?.buttonText && <UniversalButton {...cardButton} />}
        </Box>
      </Box>
    </UniversalContainer>
  );
};

FlexCardItem.displayName = 'FlexCardItem';

FlexCardItem.propTypes = {
  desktopCarousel: P.bool,
  // V2 Props
  flexCardItemContainer: P.object,
  eyebrow: P.object,
  title: P.object,
  subtitle: P.object,
  bodyCopy: P.object,
  cardImage: P.object,
  cardLabel: P.object,
  cardButton: P.object,
  alignment: P.string,
};

FlexCardItem.defaultProps = {
  desktopCarousel: false,
  // V2 Props
  flexCardItemContainer: {},
  eyebrow: {},
  title: {},
  subtitle: {},
  bodyCopy: {},
  cardImage: {},
  cardLabel: {},
  cardButton: {},
  alignment: 'flex-start',
};

export default FlexCardItem;
